module.exports = __webpack_public_path__ + "static/media/PerfilHospitalar.c0fa8156.pdf";